module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main-layout')
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c37c3e7e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/bouteille/ScanOtag.vue
// module id = 789
// module chunks = 0